export default function MissionSection() {
  return (
    <section
      className="relative py-24 md:py-32 px-8 md:px-16 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, oklch(0.22 0.018 70), oklch(0.15 0.015 70) 50%, oklch(0.12 0.012 70))',
      }}
    >
      {/* Upper stage */}
      <div className="max-w-5xl mx-auto">
        {/* Label */}
        <div className="inline-block bg-accent-500/20 px-5 py-2 rounded-md mb-10">
          <span className="text-sm font-bold font-sans text-accent-300 tracking-wide">
            / philosophy
          </span>
        </div>

        {/* Large title */}
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.15] max-w-2xl">
          We believe in software that lasts
        </h2>

        {/* Description */}
        <div className="mt-10 max-w-2xl space-y-4">
          <p className="text-base md:text-lg text-foreground-200 leading-relaxed font-body">
            The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design.
          </p>
          <p className="text-base md:text-lg text-foreground-200/70 leading-relaxed font-body">
            Every system is built with a focus on long-term technical quality, ensuring solutions remain maintainable and adaptable as technology evolves.
          </p>
          <p className="text-base md:text-lg text-foreground-200/60 leading-relaxed font-body">
            Continuous innovation drives every decision, from development workflows to the adoption of up-to-date engineering standards.
          </p>
        </div>
      </div>

      {/* Lower split stage */}
      <div className="max-w-5xl mx-auto mt-24 md:mt-32 flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
        {/* Left: abstract square */}
        <div className="w-full lg:w-[40%] flex justify-center">
          <div
            className="w-56 h-56 md:w-72 md:h-72 rounded-2xl relative overflow-hidden flex items-center justify-center"
            style={{ backgroundColor: 'oklch(0.93 0.025 84 / 0.08)' }}
          >
            {/* Inner geometric pattern */}
            <div
              className="absolute inset-4 rounded-xl"
              style={{
                background: 'radial-gradient(circle at 40% 60%, oklch(0.58 0.13 35 / 0.15), transparent 60%), linear-gradient(135deg, oklch(0.54 0.16 25 / 0.08), transparent 50%)',
              }}
            />
            <div className="absolute top-8 left-8 w-16 h-16 rounded-full border border-foreground-200/20" />
            <div className="absolute bottom-10 right-10 w-12 h-12 rounded-full border border-accent-300/15" />
            <div className="absolute top-[45%] left-[45%] w-20 h-20 rounded-full"
              style={{ background: 'radial-gradient(circle, oklch(0.72 0.04 82 / 0.2), transparent)' }}
            />
          </div>
        </div>

        {/* Right: large numeral + text */}
        <div className="w-full lg:w-[60%] flex flex-col items-start">
          <span className="font-heading text-[120px] md:text-[160px] font-bold text-background-50/90 leading-none">
            01
          </span>
          <div className="mt-4 space-y-3">
            <p className="text-base md:text-lg text-foreground-200/80 leading-relaxed font-body max-w-md">
              The company emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards.
            </p>
            <p className="text-sm md:text-base text-foreground-200/50 leading-relaxed font-body max-w-md">
              Actively exploring new technologies and evolving internal processes to maintain high technical excellence, delivering reliable and future-ready IT solutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}